// Direct import from the package
import AOS from 'aos';
import 'aos/dist/aos.css';
/* ===============================================================
  AOS Initialization Class - Optimized for Speed
=============================================================== */
class AosJs {
    constructor() {
        this.init();
    }

    init() {
        // SIMPLE FIX: Check if DOM is already loaded
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.initAos());
        } else {
            this.initAos();
        }
    }

    initAos() {
        // Quick check - if no AOS elements, skip initialization
        if (!document.querySelector('[data-aos]')) {
            return;
        }

        // Lazy load AOS if no elements found
        AOS.init({
            disable: 'mobile',
            startEvent: 'DOMContentLoaded',
            initClassName: 'aos-init',
            animatedClassName: 'aos-animate',
            useClassNames: false,
            disableMutationObserver: true,
            debounceDelay: 50,
            throttleDelay: 50,
            offset: 50,
            delay: 0,
            duration: 200,
            easing: 'ease-out',
            once: true,
            mirror: false,
            anchorPlacement: 'top-center',
        });
    }
}

export default AosJs;
